/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AccessService } from 'src/app/providers/access/access.service';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss'],
})
export class ContactPage implements OnInit {
  private previousUrl: string;
  title = "Contact Us";
  buttonlabel = "Send Enquiry";
  ishidden = false;
  type:any;
  user: any;
  contactForm: FormGroup;
  errorMessages = {
    name: [{ type: 'required', message: ' Enter Name.' }],
    email: [
      { type: 'required', message: 'An email is required.' },
      { type: 'pattern', message: 'Invalid email.' },
    ],
    colleaguefname: [{ type: 'required', message: ' Enter Colleagues First Name.' }],
    colleaguelname: [{ type: 'required', message: ' Enter Colleagues Last Name.' }],
    colleagueemail: [{ type: 'required', message: ' Enter Colleague Email.' }],
    colleaguespecialty: [{ type: 'required', message: ' Enter Colleagues Specialty.' }],
    emailto: [
      { type: 'required', message: 'Select an enquiry type.' },
      { type: 'pattern', message: 'Invalid enquiry type.' },
    ],
    message: [{ type: 'required', message: 'Please enter a message.' }]
  };
  isAdmin = false;
  isAppSupport = false;
  isAppFeatureRequest = false;
  isReferral = false;
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public formBuilder: FormBuilder,
    public apiService: ApiService,
    public toastService: ToastService,
    public accessService: AccessService,
  ) {
    this.type = this.route.snapshot.paramMap.get('type');
    if (this.type == 'Refer' || this.type == 'ReferC')
    {
      //log activity and do webhook for Flow and CRM
      if (this.type == 'Refer')
      {
        this.storageService.getObject('mbeUser').then((userResult) => {
          this.updateLog('referral_tap', userResult.id, 0);
        });
      }
      this.contactForm = this.formBuilder.group({
        name: [''],
        colleaguefname: ['', Validators.required],
        colleaguelname: ['', Validators.required],
        colleagueemail: ['', Validators.required],
        colleaguespecialty: ['', Validators.required],
        email: [''],
        emailto: [''],
        message: ['']
      });
    }
    else
    {
      this.contactForm = this.formBuilder.group({
        colleaguefname: [''],
        colleaguelname: [''],
        colleagueemail: [''],
        colleaguespecialty: [''],
        name: ['', Validators.required],
        email: [
          '',
          Validators.compose([
            Validators.required,
            // Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
          ]),
        ],
        emailto: [
          '',
          Validators.compose([
            Validators.required,
            // Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
          ]),
        ],
        message: ['', Validators.required]
      });
    }
    this.storageService.getObject('mbeUser').then((userResult) => {
      //console.log('local User::', userResult);
      if (userResult && userResult.role === '2') {
        this.isAdmin = true;
      }
      this.contactForm.patchValue({
        name: userResult.first_name + ' ' + userResult.last_name,
        email: userResult.email||''
      });
    });
  }

  ngOnInit() {
    
    if (this.type == 'Refer' || this.type == 'ReferC')
    {
      this.title = "Refer a Colleague";
      this.buttonlabel = "Send Referral";
      this.ishidden=true;
      this.isReferral=true;
    }

  }

  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }

  updateLog(type, detail, submissionid)
  {
    const params = {     
      action_type: type,
      action_detail: detail,
      data_id: submissionid,
    }
    this.apiService.post('logActivity', params).subscribe(
      (res) => {
        //console.log('activity res: ',res);    
        if (res.error === false) {      
        }
      },
      (err) => { }
    );
  }
  checkselect(e) {
    this.isAppSupport = false;
    this.isAppFeatureRequest = false;
    this.isReferral = false;
    this.contactForm.controls.message.setValue('');
    if (e.detail.value == 'appsupport@medbill.com.au')
    {
      this.isAppSupport = true;
      this.isAppFeatureRequest = false;
      this.isReferral = false;
    }   
    if (e.detail.value == 'app@medbill.com.au')
    {
      this.isAppFeatureRequest = true;
      this.isAppSupport = false;
      this.isReferral = false;
    }   
    if (e.detail.value == 'referrals@medbill.com.au')
    {
      this.router.navigateByUrl('/contact/ReferC');
    }   

  }
  contactUs() {
    //console.log('this.contactForm.controls', this.contactForm);
    if (this.contactForm.valid) {
      this.toastService.presentLoading();
      var payload = {
        name: this.contactForm.controls.name.value,
        emailto: this.contactForm.controls.emailto.value.trim(),
        email: this.contactForm.controls.email.value.trim(),
        colleaguefname: '',
        colleaguelname: '',
        colleagueemail: '',
        colleaguespecialty: '',
        message: this.contactForm.controls.message.value,
        User: this.contactForm.controls.value
      };
      if (this.type == 'Refer' || this.type == 'ReferC')
      {
        payload = {
          name: this.contactForm.controls.name.value,
          emailto: 'referrals@medbill.com.au',
          email: this.contactForm.controls.email.value.trim(),
          colleaguefname: this.contactForm.controls.colleaguefname.value,
          colleaguelname: this.contactForm.controls.colleaguelname.value,
          colleagueemail: this.contactForm.controls.colleagueemail.value,
          colleaguespecialty: this.contactForm.controls.colleaguespecialty.value,
          message: 'Colleagues Name: '+this.contactForm.controls.colleaguefname.value+' '+this.contactForm.controls.colleaguelname.value+'<br>Colleagues Email: '+this.contactForm.controls.colleagueemail.value+'<br>Colleagues Specialty: '+this.contactForm.controls.colleaguespecialty.value,
          User: this.contactForm.controls.value
        };
      }
      else if (this.isReferral)
      {
        payload = {
          name: this.contactForm.controls.name.value,
          emailto: 'referrals@medbill.com.au',
          email: this.contactForm.controls.email.value.trim(),
          colleaguefname: '',
          colleaguelname: '',
          colleagueemail: '',
          colleaguespecialty: '',
          message: 'Referral:<br>'+this.contactForm.controls.message.value,
          User: this.contactForm.controls.value
        };
      }
      this.apiService.post('contact-us', payload).subscribe(
        (res) => {
          this.toastService.dismissLoading();
          if (res.error === false) {
            this.contactForm.controls.message.reset();
            if (this.type == 'Refer' || this.type == 'ReferC')
            {
              this.toastService.presentToast('success', 'Thank you!<br>Your referral was sent successfully');
            }
            else
            {
              this.toastService.presentToast('success', 'Your enquiry was sent successfully');
            }
            this.router.navigateByUrl('/home');
          }
        },
        (err) => {
          this.toastService.dismissLoading();
          //console.log(err);
        }
      );
    } else {
      // eslint-disable-next-line guard-for-in
      for (const property in this.contactForm.value) {
        this.contactForm.controls[property].markAsTouched();
      }
      this.contactForm.markAsTouched();
    }
  }

}
